import { createSelector } from 'reselect'
import settingsEnums from '../../../helpers/enums/settings'
import { IStore } from '../../reducers/index'

const settingsSelector = (state: IStore) => state.game.settings
const featureFlagsSelector = (state: IStore) => state.app.featureFlags

const getSkinsValues = (settings: any[]) => {
	const availableSkinsSettings = settings.find((setting) => setting.id === settingsEnums.SETTING_AVAILABLE_SKINS)
	const values = availableSkinsSettings
		? availableSkinsSettings.value
		: [settingsEnums.SETTING_SKIN_DEFAULT, settingsEnums.SETTING_SKIN_SPACE]
	return {
		values,
	}
}

export default createSelector(settingsSelector, featureFlagsSelector, (settings, featureFlags) => {
	const settingsToShow: string[] = [
		settingsEnums.SETTING_TYPE_ANSWERS_MODE,
		settingsEnums.SETTING_TYPE_SKIN,
		settingsEnums.SETTING_TYPE_AUDIO,
	]

	settingsToShow.push(settingsEnums.SETTING_TYPE_PAUSE)
	settingsToShow.push(settingsEnums.SETTING_TYPE_ANIMATIONS)

	const isTimerDisabledSetting = settings.find((s: any) => s.id === settingsEnums.SETTING_TYPE_TIMER_DISABLED)
	const shouldShowTimerDisabled =
		(isTimerDisabledSetting && ([
			settingsEnums.SETTING_TIMER_DISABLED_FROM_SESSION,
			settingsEnums.SETTING_TIMER_DISABLED_FROM_CREATION
		].includes(isTimerDisabledSetting.value))) ||
		featureFlags?.teacherDisableTTCTimer === true

	if (shouldShowTimerDisabled) {
		settingsToShow.push(settingsEnums.SETTING_TYPE_TIMER_DISABLED)
	}

	return settings
		.filter((setting: any) => settingsToShow.includes(setting.id))
		.map((setting: any) => {
			if (setting.id === settingsEnums.SETTING_TYPE_SKIN) {
				return {
					...setting,
					...getSkinsValues(settings),
				}
			} else {
				return setting
			}
		})
})
